import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { setToken } from "../lib/auth";

export function LoginPage() {
  const [token, setLocalToken] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const navigate = useNavigate();

  function submit(e: React.FormEvent) {
    e.preventDefault();
    if (!token.trim()) { setErr("paste your DASHBOARD_SECRET"); return; }
    setToken(token.trim());
    navigate("/sites", { replace: true });
  }

  return (
    <div className="min-h-screen bg-ink-50 flex items-center justify-center px-4">
      <form onSubmit={submit} className="bg-white border border-ink-100 rounded-2xl shadow-lg p-8 w-full max-w-md">
        <h1 className="text-2xl font-display font-bold mb-1">RankForge Dashboard</h1>
        <p className="text-ink-600 text-sm mb-6">
          Paste the <code className="bg-ink-100 px-1 py-0.5 rounded">DASHBOARD_SECRET</code> set on
          the lead-receiver Worker. Stays in this browser only — no server-side session.
        </p>
        <label className="block text-sm font-medium text-ink-600 mb-1">Secret</label>
        <input
          type="password"
          value={token}
          onChange={(e) => setLocalToken(e.target.value)}
          autoFocus
          placeholder="paste DASHBOARD_SECRET hex…"
          className="w-full px-3 py-2.5 border-2 border-ink-100 rounded-lg focus:border-accent focus:outline-none font-mono text-sm"
        />
        {err && <p className="text-red-600 text-sm mt-2">{err}</p>}
        <button
          type="submit"
          className="mt-5 w-full bg-accent hover:bg-accent-600 text-white font-semibold py-2.5 rounded-lg transition-colors"
        >Sign in</button>
      </form>
    </div>
  );
}
